import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button, Table, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Plus } from 'react-bootstrap-icons';
import EMMSectionHeader from './EMMSectionHeader';
import { useAccount } from '../contexts/AccountContext';

const CampaignList = () => {
  const { selectedAccount, isAllAccountsSelected } = useAccount();
  const [campaigns, setCampaigns] = useState([]);

  useEffect(() => {
    // TODO: Fetch campaigns from API - ACCOUNT SPECIFIC
    // No mock data - show empty state until real API is connected
    setCampaigns([]);
  }, [selectedAccount.id, isAllAccountsSelected]);

  const getStatusBadge = (status) => {
    const variants = {
      draft: 'secondary',
      scheduled: 'warning',
      sent: 'success',
      failed: 'danger'
    };
    return <Badge bg={variants[status] || 'secondary'}>{status}</Badge>;
  };

  return (
    <>
      <EMMSectionHeader title="Email Campaigns" showHelp />
      <Container className="mt-3">
      {/* Action bar - same spot and size as Clients "+ Client" button */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="d-flex align-items-center gap-2">
          <Button
            as={Link}
            to="/campaigns/create"
            variant="primary"
            size="sm"
            className="d-flex align-items-center"
            style={{ fontSize: '0.75rem', padding: '0.25rem 0.5rem' }}
          >
            <Plus className="me-1" size={14} />
            Campaign
          </Button>
          <span className="text-muted" style={{ fontSize: '0.75rem' }}>{campaigns.length} campaigns</span>
        </div>
      </div>
      <Row>
        <Col>
          <Card>
            <Card.Body>
              <Table responsive>
                <thead>
                  <tr>
                    <th>Campaign Name</th>
                    <th>Status</th>
                    <th>Subscribers</th>
                    <th>Sent Date</th>
                    <th>Open Rate</th>
                    <th>Click Rate</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {campaigns.length === 0 ? (
                    <tr>
                      <td colSpan="7" className="text-center text-muted py-4">
                        <p>No campaigns found</p>
                        <small>Create your first campaign to get started.</small>
                      </td>
                    </tr>
                  ) : (
                    campaigns.map((campaign) => (
                      <tr key={campaign.id}>
                        <td>
                          <strong>{campaign.name}</strong>
                        </td>
                        <td>{getStatusBadge(campaign.status)}</td>
                        <td>{campaign.subscribers.toLocaleString()}</td>
                        <td>{campaign.sentDate || 'Not sent'}</td>
                        <td>{campaign.openRate}%</td>
                        <td>{campaign.clickRate}%</td>
                        <td>
                          <Button size="sm" variant="outline-primary" className="me-2">
                            Edit
                          </Button>
                          <Button size="sm" variant="outline-danger">
                            Delete
                          </Button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
    </>
  );
};

export default CampaignList;

